var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2DataManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 24h4v39h-4V24zm-12.7-2H37.23L20.67 37H12v3.92h10.2L38.77 26h9.93L64 13.76V8.64L47.3 22zM52 63h4V31h-4v32zm-8 0h4V31h-4v32zm-8 0h4V37h-4v26zm-8 0h4V43h-4v20zm-8 0h4V47h-4v16zm-8 0h4V47h-4v16z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Data_management.38be2b7d.svg";
export { SvgJ2DataManagement as ReactComponent };